
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    console.error(
      t(
        "404 Error: Uživatel se pokusil přistoupit k neexistující trase:", 
        "404 Error: Užívateľ sa pokúsil pristúpiť k neexistujúcej trase:"
      ),
      location.pathname
    );
  }, [location.pathname, t]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center p-6">
        <h1 className="text-6xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-6">
          {t("Jejda! Stránka nenalezena", "Jejda! Stránka nenájdená")}
        </p>
        <p className="text-gray-500 mb-8">
          {t("Zdá se, že stránka, kterou hledáš, neexistuje nebo byla přesunuta.", 
             "Zdá sa, že stránka, ktorú hľadáš, neexistuje alebo bola presunutá.")}
        </p>
        <Link to="/" className="text-white bg-blue-600 hover:bg-blue-700 px-6 py-3 rounded-md transition-colors">
          {t("Vrátit se na domovskou stránku", 
             "Vrátiť sa na domovskú stránku")}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
